import React, { useState, useEffect} from 'react';
import '../../css/pages.css';
import language from '../../utils/LanguageSettings';
import { fetchSubscriberEnquiry } from '../functions/fetchSubscriberEnquiry';
import { SOURCE_URL } from '../../config';
import ReactMarkdown, { defaultUrlTransform } from 'react-markdown';
import gfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import RenderSnA from '../functions/renderSnA';
import { useMinisiteLayout, HeaderMode, FooterMode } from '../../contexts/MinisiteLayoutContext';

interface SEO {
  Title: string;
  MetaDescription: string;
  MetaKeywords: string;
  MetaImage: string;
}

const OTTSubscriberEnquiry: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [content, setContent] = useState<any>();
  const [seo, setSeo] = useState<any>(null);
  const [ga, setGa] = useState<any>(null);
  const [minHeight, setMinHeight] = useState<number>(0);
  const { setLayout, resetLayout } = useMinisiteLayout();

  useEffect(() => {
    const fetchData = async () => {
        let data = await fetchSubscriberEnquiry(language);
        if(data){
          const attributes = data?.attributes;
          setContent(attributes);
          setSeo(attributes?.OTTSEO || null);
          setGa(attributes?.OTTGA || null);

          // Handle Header Mode
          let headerMode: HeaderMode = 'general';
          if (attributes?.OTTHideHeaderMenuAndSearchBar) {
            headerMode = 'logo-lang-enquiry';
          }

          // Handle Footer Mode
          let footerMode: FooterMode = 'general';
          if (attributes?.OTTFooterMenu === 'Hidden') {
            footerMode = 'hidden';
          } else if (attributes?.OTTFooterMenu === 'Footer Menu Only') {
            footerMode = 'footer-only';
          }

          setLayout(headerMode, footerMode);
        }
        setLoading(false);
    };
    fetchData();

    return () => {
      resetLayout();
    };
  }, [language, setLayout, resetLayout]);

  useEffect(() => {
    const navbarElement = document.querySelector('.navbar');
    let header_height = 0;
    if (navbarElement) {
        header_height = navbarElement.offsetHeight;
        const computedStyle = getComputedStyle(navbarElement);
        const marginTop = parseFloat(computedStyle.marginTop);
        const marginBottom = parseFloat(computedStyle.marginBottom);
        header_height += marginTop + marginBottom;
    }

    const footerElement = document.querySelector('footer');
    let footer_height = 0;
    if (footerElement) {
        footer_height = footerElement.offsetHeight;
        const computedStyle = getComputedStyle(footerElement);
        const marginTop = parseFloat(computedStyle.marginTop);
        const marginBottom = parseFloat(computedStyle.marginBottom);
        footer_height += marginTop + marginBottom;
    }
    setMinHeight(footer_height + header_height);
  },[language])

  const handleSalesChannles = (items: any) => {
    return Array.isArray(items) && items.map((item, index) => (
        <div className='col-md-3 col-sm-6 mb-4' key={index}>
            <a href={item?.Link}>
              <img src={SOURCE_URL + item?.Icon?.data?.attributes?.url} className='img-fluid chat-call-icons d-block mx-auto'/>
              <span className='font-weight-bold barlow-font d-block mt-3'>{item?.Label}</span>
              <span className='light-gray barlow-font d-block mt-2'>{item?.SubLabel}</span>
            </a>
        </div>
    ))
  }
  


  if (loading) {
    return (<>
        <div id="loader">
            <div className="spinner-border"></div>
        </div>
    </>
    );
  }
  
  return (
    <>
    <RenderSnA seo={seo} ga={ga} />
    <section id="main-content" className="spacer ott-enquiry" style={{minHeight:"calc(100vh - "+minHeight+"px"}}>
      <div className="container-fluid container-md text-center">
        <h2 className='font-medium mb-3'>{content?.OTTHeaderTagline}</h2>
        <div className='my-5 light-gray barlow-font text-18'>
          <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{content?.OTTIntroduction?.replace(/\n/g, '<br />') || ''}</ReactMarkdown>
        </div>
        {content?.OTTSalesChannels ? 
        <div className='row justify-content-center mb-4'>
          {handleSalesChannles(content?.OTTSalesChannels)}
        </div>
        :<></>}
      </div>
    </section>
    </>
  );
};

export default OTTSubscriberEnquiry;